function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _updateFilesAndFolders, _isOriginAllowed, _temp;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('preact'),
    h = _require.h;

var AuthView = require('./AuthView');

var Header = require('./Header');

var Browser = require('../Browser');

var LoaderView = require('../Loader');

var CloseWrapper = require('../CloseWrapper');

var View = require('../View');

function getOrigin() {
  // eslint-disable-next-line no-restricted-globals
  return location.origin;
}
/**
 * Class to easily generate generic views for Provider plugins
 */


module.exports = (_temp = (_updateFilesAndFolders = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndFolders"), _isOriginAllowed = /*#__PURE__*/_classPrivateFieldLooseKey("isOriginAllowed"), _class = /*#__PURE__*/function (_View) {
  _inherits(ProviderView, _View);

  var _super = _createSuper(ProviderView);

  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  function ProviderView(plugin, opts) {
    var _this2;

    _classCallCheck(this, ProviderView);

    _this2 = _super.call(this, plugin, opts); // set default options

    Object.defineProperty(_assertThisInitialized(_this2), _isOriginAllowed, {
      value: _isOriginAllowed2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _updateFilesAndFolders, {
      value: _updateFilesAndFolders2
    });
    var defaultOptions = {
      viewType: 'list',
      showTitles: true,
      showFilter: true,
      showBreadcrumbs: true
    }; // merge default options with the ones set by user

    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // Logic

    _this2.filterQuery = _this2.filterQuery.bind(_assertThisInitialized(_this2));
    _this2.getFolder = _this2.getFolder.bind(_assertThisInitialized(_this2));
    _this2.getNextFolder = _this2.getNextFolder.bind(_assertThisInitialized(_this2));
    _this2.logout = _this2.logout.bind(_assertThisInitialized(_this2));
    _this2.handleAuth = _this2.handleAuth.bind(_assertThisInitialized(_this2));
    _this2.handleScroll = _this2.handleScroll.bind(_assertThisInitialized(_this2));
    _this2.listAllFiles = _this2.listAllFiles.bind(_assertThisInitialized(_this2));
    _this2.donePicking = _this2.donePicking.bind(_assertThisInitialized(_this2)); // Visual

    _this2.render = _this2.render.bind(_assertThisInitialized(_this2)); // Set default state for the plugin

    _this2.plugin.setPluginState({
      authenticated: false,
      files: [],
      folders: [],
      directories: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });

    return _this2;
  }

  _createClass(ProviderView, [{
    key: "tearDown",
    value: function tearDown() {// Nothing.
    }
    /**
     * Based on folder ID, fetch a new folder and update it to state
     *
     * @param  {string} id Folder id
     * @returns {Promise}   Folders/files in folder
     */

  }, {
    key: "getFolder",
    value: function getFolder(id, name) {
      var _this3 = this;

      return this.sharedHandler.loaderWrapper(this.provider.list(id), function (res) {
        var folders = [];
        var files = [];
        var updatedDirectories;

        var state = _this3.plugin.getPluginState();

        var index = state.directories.findIndex(function (dir) {
          return id === dir.id;
        });

        if (index !== -1) {
          updatedDirectories = state.directories.slice(0, index + 1);
        } else {
          updatedDirectories = state.directories.concat([{
            id: id,
            title: name
          }]);
        }

        _this3.username = res.username || _this3.username;

        _classPrivateFieldLooseBase(_this3, _updateFilesAndFolders)[_updateFilesAndFolders](res, files, folders);

        _this3.plugin.setPluginState({
          directories: updatedDirectories
        });
      }, this.handleError);
    }
    /**
     * Fetches new folder
     *
     * @param  {object} folder
     */

  }, {
    key: "getNextFolder",
    value: function getNextFolder(folder) {
      this.getFolder(folder.requestPath, folder.name);
      this.lastCheckbox = undefined;
    }
    /**
     * Removes session token on client side.
     */

  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;

      this.provider.logout().then(function (res) {
        if (res.ok) {
          if (!res.revoked) {
            var message = _this4.plugin.uppy.i18n('companionUnauthorizeHint', {
              provider: _this4.plugin.title,
              url: res.manual_revoke_url
            });

            _this4.plugin.uppy.info(message, 'info', 7000);
          }

          var newState = {
            authenticated: false,
            files: [],
            folders: [],
            directories: []
          };

          _this4.plugin.setPluginState(newState);
        }
      }).catch(this.handleError);
    }
  }, {
    key: "filterQuery",
    value: function filterQuery(e) {
      var state = this.plugin.getPluginState();
      this.plugin.setPluginState(_objectSpread(_objectSpread({}, state), {}, {
        filterInput: e ? e.target.value : ''
      }));
    }
    /**
     * Adds all files found inside of specified folder.
     *
     * Uses separated state while folder contents are being fetched and
     * mantains list of selected folders, which are separated from files.
     */

  }, {
    key: "addFolder",
    value: function addFolder(folder) {
      var _this5 = this;

      var folderId = this.providerFileToId(folder);
      var state = this.plugin.getPluginState();

      var folders = _objectSpread({}, state.selectedFolders);

      if (folderId in folders && folders[folderId].loading) {
        return;
      }

      folders[folderId] = {
        loading: true,
        files: []
      };
      this.plugin.setPluginState({
        selectedFolders: _objectSpread({}, folders)
      }); // eslint-disable-next-line consistent-return

      return this.listAllFiles(folder.requestPath).then(function (files) {
        var count = 0; // If the same folder is added again, we don't want to send
        // X amount of duplicate file notifications, we want to say
        // the folder was already added. This checks if all files are duplicate,
        // if that's the case, we don't add the files.

        files.forEach(function (file) {
          var id = _this5.providerFileToId(file);

          if (!_this5.plugin.uppy.checkIfFileAlreadyExists(id)) {
            count++;
          }
        });

        if (count > 0) {
          files.forEach(function (file) {
            return _this5.addFile(file);
          });
        }

        var ids = files.map(_this5.providerFileToId);
        folders[folderId] = {
          loading: false,
          files: ids
        };

        _this5.plugin.setPluginState({
          selectedFolders: folders
        });

        var message;

        if (count === 0) {
          message = _this5.plugin.uppy.i18n('folderAlreadyAdded', {
            folder: folder.name
          });
        } else if (files.length) {
          message = _this5.plugin.uppy.i18n('folderAdded', {
            smart_count: count,
            folder: folder.name
          });
        } else {
          message = _this5.plugin.uppy.i18n('emptyFolderAdded');
        }

        _this5.plugin.uppy.info(message);
      }).catch(function (e) {
        var state = _this5.plugin.getPluginState();

        var selectedFolders = _objectSpread({}, state.selectedFolders);

        delete selectedFolders[folderId];

        _this5.plugin.setPluginState({
          selectedFolders: selectedFolders
        });

        _this5.handleError(e);
      });
    }
  }, {
    key: "handleAuth",
    value: function () {
      var _handleAuth = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var authState, clientVersion, link, authWindow, handleToken;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.provider.ensurePreAuth();

              case 2:
                authState = btoa(JSON.stringify({
                  origin: getOrigin()
                }));
                clientVersion = "@uppy/provider-views=".concat(ProviderView.VERSION);
                link = this.provider.authUrl({
                  state: authState,
                  uppyVersions: clientVersion
                });
                authWindow = window.open(link, '_blank');

                handleToken = function handleToken(e) {
                  if (!_classPrivateFieldLooseBase(_this6, _isOriginAllowed)[_isOriginAllowed](e.origin, _this6.plugin.opts.companionAllowedHosts) || e.source !== authWindow) {
                    _this6.plugin.uppy.log("rejecting event from ".concat(e.origin, " vs allowed pattern ").concat(_this6.plugin.opts.companionAllowedHosts));

                    return;
                  } // Check if it's a string before doing the JSON.parse to maintain support
                  // for older Companion versions that used object references


                  var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;

                  if (data.error) {
                    _this6.plugin.uppy.log('auth aborted');

                    var uppy = _this6.plugin.uppy;
                    var message = uppy.i18n('authAborted');
                    uppy.info({
                      message: message
                    }, 'warning', 5000);
                    return;
                  }

                  if (!data.token) {
                    _this6.plugin.uppy.log('did not receive token from auth window');

                    return;
                  }

                  authWindow.close();
                  window.removeEventListener('message', handleToken);

                  _this6.provider.setAuthToken(data.token);

                  _this6.preFirstRender();
                };

                window.addEventListener('message', handleToken);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleAuth() {
        return _handleAuth.apply(this, arguments);
      }

      return handleAuth;
    }()
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
        var path, response, _this$plugin$getPlugi, files, folders;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                path = this.nextPagePath || null;

                if (!(this.shouldHandleScroll(event) && path)) {
                  _context2.next = 17;
                  break;
                }

                this.isHandlingScroll = true;
                _context2.prev = 3;
                _context2.next = 6;
                return this.provider.list(path);

              case 6:
                response = _context2.sent;
                _this$plugin$getPlugi = this.plugin.getPluginState(), files = _this$plugin$getPlugi.files, folders = _this$plugin$getPlugi.folders;

                _classPrivateFieldLooseBase(this, _updateFilesAndFolders)[_updateFilesAndFolders](response, files, folders);

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                this.handleError(_context2.t0);

              case 14:
                _context2.prev = 14;
                this.isHandlingScroll = false;
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 11, 14, 17]]);
      }));

      function handleScroll(_x) {
        return _handleScroll.apply(this, arguments);
      }

      return handleScroll;
    }()
  }, {
    key: "listAllFiles",
    value: function listAllFiles(path, files) {
      var _this7 = this;

      if (files === void 0) {
        files = null;
      }

      files = files || [];
      return new Promise(function (resolve, reject) {
        _this7.provider.list(path).then(function (res) {
          res.items.forEach(function (item) {
            if (!item.isFolder) {
              files.push(item);
            } else {
              _this7.addFolder(item);
            }
          });
          var moreFiles = res.nextPagePath || null;

          if (moreFiles) {
            return _this7.listAllFiles(moreFiles, files).then(function (files) {
              return resolve(files);
            }).catch(function (e) {
              return reject(e);
            });
          }

          return resolve(files);
        }).catch(function (e) {
          return reject(e);
        });
      });
    }
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this8 = this;

      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi2.currentSelection;

      var promises = currentSelection.map(function (file) {
        if (file.isFolder) {
          return _this8.addFolder(file);
        }

        return _this8.addFile(file);
      });
      this.sharedHandler.loaderWrapper(Promise.all(promises), function () {
        _this8.clearSelection();
      }, function () {});
    }
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;

      if (viewOptions === void 0) {
        viewOptions = {};
      }

      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          authenticated = _this$plugin$getPlugi3.authenticated,
          didFirstRender = _this$plugin$getPlugi3.didFirstRender;

      if (!didFirstRender) {
        this.preFirstRender();
      }

      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);

      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
          files = _this$plugin$getPlugi4.files,
          folders = _this$plugin$getPlugi4.folders,
          filterInput = _this$plugin$getPlugi4.filterInput,
          loading = _this$plugin$getPlugi4.loading,
          currentSelection = _this$plugin$getPlugi4.currentSelection;

      var _this$sharedHandler = this.sharedHandler,
          isChecked = _this$sharedHandler.isChecked,
          toggleCheckbox = _this$sharedHandler.toggleCheckbox,
          filterItems = _this$sharedHandler.filterItems;
      var hasInput = filterInput !== '';
      var headerProps = {
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        getFolder: this.getFolder,
        directories: this.plugin.getPluginState().directories,
        pluginIcon: this.plugin.icon,
        title: this.plugin.title,
        logout: this.logout,
        username: this.username,
        i18n: this.plugin.uppy.i18n
      };
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        username: this.username,
        getNextFolder: this.getNextFolder,
        getFolder: this.getFolder,
        filterItems: this.sharedHandler.filterItems,
        filterQuery: this.filterQuery,
        logout: this.logout,
        handleScroll: this.handleScroll,
        listAllFiles: this.listAllFiles,
        done: this.donePicking,
        cancel: this.cancelPicking,
        headerComponent: Header(headerProps),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;

          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        }
      };

      if (loading) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(LoaderView, {
          i18n: this.plugin.uppy.i18n
        }));
      }

      if (!authenticated) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(AuthView, {
          pluginName: this.plugin.title,
          pluginIcon: this.plugin.icon,
          handleAuth: this.handleAuth,
          i18n: this.plugin.uppy.i18n,
          i18nArray: this.plugin.uppy.i18nArray
        }));
      }

      return h(CloseWrapper, {
        onUnmount: this.clearSelection
      }, h(Browser, browserProps));
    }
  }]);

  return ProviderView;
}(View)), _class.VERSION = "2.0.8", _temp);

function _updateFilesAndFolders2(res, files, folders) {
  this.nextPagePath = res.nextPagePath;
  res.items.forEach(function (item) {
    if (item.isFolder) {
      folders.push(item);
    } else {
      files.push(item);
    }
  });
  this.plugin.setPluginState({
    folders: folders,
    files: files
  });
}

function _isOriginAllowed2(origin, allowedOrigin) {
  var getRegex = function getRegex(value) {
    if (typeof value === 'string') {
      return new RegExp("^".concat(value, "$"));
    }

    if (value instanceof RegExp) {
      return value;
    }
  };

  var patterns = Array.isArray(allowedOrigin) ? allowedOrigin.map(getRegex) : [getRegex(allowedOrigin)];
  return patterns.filter(function (pattern) {
    return pattern != null;
  }) // loose comparison to catch undefined
  .some(function (pattern) {
    return pattern.test(origin) || pattern.test("".concat(origin, "/"));
  }); // allowing for trailing '/'
}